import { useEffect, Suspense, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { lazyRoute } from '@/routing/lazyRoute';
import { leaveAsIfNotHere, useAsIfState } from './asIfView';

/**
 * F-0709 ASIF-29: the page a place a view cannot go draws (`403 as-if-not-here`) replaces the screen that
 * asked, and goes away when the reader leaves the place (a change of address). The gate is all the entry
 * carries, with no words: the page, its catalogue area and its API are their own chunk, fetched only by
 * a tab that holds a view and was refused (`check-first-screen-chunks.mjs`).
 */
const AsIfNotHerePage = lazyRoute(
  () => import('./AsIfNotHerePage'),
  (module) => module.AsIfNotHerePage,
);

export function AsIfNotHereGate({ children }: { children: ReactNode }) {
  const { view, notHere } = useAsIfState();
  const location = useLocation();
  useEffect(() => {
    leaveAsIfNotHere();
  }, [location.pathname]);
  if (view && notHere !== null) {
    return (
      <Suspense fallback={null}>
        <AsIfNotHerePage />
      </Suspense>
    );
  }
  return <>{children}</>;
}
